module.exports = __webpack_public_path__ + "img/ic_sideways_plane.fb654a7a.svg";